import { Spin } from 'antd';
import { useSpin } from '../components/SpinContext';

const Spinner = () => {
  const { loading } = useSpin();
  return (
    loading && (
      <div className='spinner-overlay'>
        <Spin size='large' />
      </div>
    )
  );
};

export default Spinner;
